import { useState } from "react"
import styled from "styled-components"
import SearchBar from "../common/SearchBar"
import ModalBootstrap from "../common/ModalBootstrap"
import PlayerProfile from "./PlayerProfile"
import UserService from "../../services/user"
import TeamService from "../../services/team"
import ContractService from "../../services/contract"
import HelperService from "../../services/helper"
import { FC } from "react"
import { User } from "../../models/user"
import { CreateContractDTO } from "../../models/contract"
import { Team } from "../../models/team"
import useNotyf from "../../context/useNotify"
import { QueryParams } from "../../models/misc"
import placeholderImage from "../../images/common/vgc-logo.png"
import ReactModal from "../common/ReactModal"

const SearchUser: FC = () => {
  const notyf = useNotyf()

  // Data
  const [player, setPlayer] = useState<User | null>()
  const [teamOptions, setTeamOptions ] = useState<Team[]>()
  const [seasons, setSeasons] = useState(5);

  // API
  const offerContract = async (teamId: string) => {
    try {
      if (!player) {
        return
      }
      const dto: CreateContractDTO = {
        seasons: seasons,
        teamId: teamId,
        playerId: player._id
      }
      await ContractService.createContract(dto)
      notyf.success("Contract offer out! 📄⚽️ Await the player's play call!")
    } catch (err) {
      console.log(err);
      HelperService.showNotfyErr(notyf, err, "Error sending contract.");
    } finally {
      closeModal()
    }
  }

  const searchTeams = async () => {
    try {
      const teams = await TeamService.getTeams({ isManager: true })
      return teams
    } catch (err) {
      console.log(err);
      HelperService.showNotfyErr(notyf, err, "Error finding teams.");
    }
  }

  const searchUser = async (username: string) => {
    try {
      const { user } = await UserService.readUserByUsername(username)
      if (!user) {
        throw new Error("User not found.")
      }
      setPlayer(user)
      openModal()
    } catch (err) {
      console.log(err);
      HelperService.showNotfyErr(notyf, err, "User not found.");
    }
  }

  // Methods
  const handleInputChange = (e: any) => {
    setSeasons(e.target.value);
  };

  const handleClickOfferContract = async () => {
    const teams = await searchTeams()
    if (!teams || !teams.data.length) {
      notyf.error("Only managers can send contracts ")
      return
    }
    if (teams.data.length === 1) {
      offerContract(teams.data[0]._id)
    }
    if (teams.data.length > 1) {
      setTeamOptions(teams.data)
    }
  }

  const handleClickTeamOption = async (teamId: string) => {
    offerContract(teamId)
  }

  // modal
  const [modalOpen, setModalOpen] = useState(false)

  const openModal = () => {
    setModalOpen(true)
  }
  const closeModal = () => {
    setModalOpen(false)
    setTeamOptions(undefined)
    setSeasons(5)
  }

  return (
    <Wrapper>
      <Container className="gradient-gr gray-border">
        <InnerContainer className="gradient-gray-light ">
          <SearchContainer>
            <TextContainer>
              <P>Search the transfer market.</P>
            </TextContainer>
            <SearchBarContainer>
              <SearchBar func={searchUser} placeholder={"Enter username..."} />
            </SearchBarContainer>
          </SearchContainer>

          {modalOpen &&
            (player ? (
              <ReactModal
                modalOpen={modalOpen}
                closeModal={closeModal}
              component={
                <>
                  {/* <PlayerProfile player={player} /> */}
                  <div className="h-100 d-flex flex-column justify-content-center p-3">
                    <div className="row px-5 px-2">
                      <div className="col-12">
                        <h3 className="text-center my-3 heading">{player.username}'s Profile</h3>
                      </div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                      <div className="col-12 col-md-6 text-center">
                      <img src={player.profileImage || placeholderImage} alt="Team Logo" className="img-fluid" style={{ maxHeight: '200px' }} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 text-center d-flex flex-column align-items-center my-2">
                      <h5>{player.username}</h5>
                        <p>In {player.leagues.length} leagues</p>
                      </div>
                    </div>
                    <div className="mx-1 mb-2">
                        <label className="form-label text-white mb-1">Number of Seasons</label>
                        <input type="number" id="seasonsInput" className="form-control bg-dark text-white" value={seasons} onChange={handleInputChange} />
                      </div>

                  {/* Show team options if the manager has many teams */}
                    <div className="row justify-content-center">
                    <div className="col-6 col-sm-4 w-100 d-flex justify-content-center">
                      {teamOptions?.length ?
                        <div className=" d-flex flex-column">
                        <label htmlFor="seasonsInput">Select which team</label>
                        <div className="d-flex gap-3 flex-wrap">
                          {teamOptions.map(team => 
                            <button className="btn btn-primary btn-sm" onClick={() => handleClickTeamOption(team._id)} key={team._id}>
                              {team.name}
                            </button>
                          )}
                        </div>
                    </div>
                      : 
                        <button onClick={handleClickOfferContract} className="btn btn-success w-100 m-1">OFFER CONTRACT</button>
                      }
                      </div>
                    </div>
                  </div>
                </>}
              />
            ) : (
              <ModalBootstrap
                title={"No player found."}
                submitText={""}
                html={""}
                closeModal={closeModal}
                submitButton={false}
                component={
                  <p>Sorry, we couldn't find a player with that username.</p>
                }
                submitFunc={handleClickOfferContract}
              />
            ))}
        </InnerContainer>
      </Container>
    </Wrapper>
  )
}

export default SearchUser
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
`
const Container = styled.div`
  padding: 0.5rem;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  border-radius: 8px;
  max-width:350px;
  width: 100%;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 4px 0.5px #00eaff;
`
const TextContainer = styled.div`
  padding: 0;
  margin: 0;
`
const P = styled.p`
  padding: 0;
  margin: 0;
`
const InnerContainer = styled.div`
  width: 100%;
  min-height: 100%;
  background: linear-gradient(120deg, #000000ff 60%, #040a2cff 100%);
  border-radius: 8px;
  padding: 1rem;
`
const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
`
const SearchBarContainer = styled.div`
  width: 100%;
  margin-top: 0.3rem;
  border: 2px solid #5fa8e6;
  border-radius: 8px;
  box-shadow: 0 0 4px 0.5px #00eaff;
`
